const doc = [({"da":({"js":({"admin":({"components":({"photo_session_csvs":({"table":({"file":"Fil"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;